import * as yup from 'yup';

const validationSchema = formatMessage =>
  yup
    .object()
    .shape({
      serviceType: yup.string().nullable(),
      serviceTypeCode: yup.string().nullable(),
      status: yup.string().nullable(),
    })
    .test(
      'at-least-one-required',
      formatMessage({
        id: 'ATLEASTONE_FIELD_IS_REQUIRED',
        defaultMessage: 'At least one field is required',
      }),
      // eslint-disable-next-line arrow-body-style
      value => {
        return value &&
          typeof value === 'object' &&
          Object.values(value).length > 0 &&
          !Array.isArray(value)
          ? Object.values(value).some(val => val && val !== '')
          : false;
      },
    );

export default validationSchema;
